export const websiteNeeds: string[] = [
  'Services and offers',
  'Quote requests',
  'Online store',
  'Customer follow-up',
  'Tools and updates',
]

export const systemModules: { label: string; note: string; accent: 'orange' | 'cyan' | 'green' }[] = [
  { label: 'Pages', note: 'Every service, one structure', accent: 'cyan' },
  { label: 'Lead paths', note: 'Call, form, quote, book', accent: 'orange' },
  { label: 'Ecommerce', note: '0% transaction fees from us', accent: 'green' },
  { label: 'Integrations', note: 'Connected to your systems', accent: 'cyan' },
  { label: 'Updates & support', note: 'Hosted, secured, kept current', accent: 'orange' },
]
